export const ROLE_LABEL = {
  super_admin: "Super Admin",
  founder: "Founder / Executive",
  administrator: "Administrator",
  vp_director: "VP / Director",
  recruitment_manager: "Recruitment Manager",
  bdm: "BDM / Account Manager",
  team_lead: "Team Lead",
  member: "Team Member",
  recruiter: "Recruiter",
  research_analyst: "Research Analyst",
  hr: "HR",
  hr_admin: "HR Admin",
  payroll_admin: "Payroll Admin",
  team_admin: "Team Admin",
  finance: "Finance",
  auditor: "Auditor / Read Only",
  client_portal: "Client Portal User",
  candidate_portal: "Candidate Portal User",
};
